import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Check environment in development
if (process.env.NODE_ENV === 'development') {
  import('./utils/checkEnv');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);